import { render, staticRenderFns } from "./FormBuilderSidebar.vue?vue&type=template&id=4eb5e48e&scoped=true"
import script from "./FormBuilderSidebar.vue?vue&type=script&lang=js"
export * from "./FormBuilderSidebar.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderSidebar.vue?vue&type=style&index=0&id=4eb5e48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5e48e",
  null
  
)

export default component.exports